import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, Input, Select } from 'semantic-ui-react';

export default class FilterBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: '',
      gravita: null,
    };
  }

  handleSearchEnter = (event) => {
    if (event.which === 13) {
      event.preventDefault();
      this.applyFilters();
    }
  };

  applyFilters = () => {
    const filters = {
      message: this.state.message || null,
      gravita: this.state.gravita !== '--' ? this.state.gravita : null,
    };

    this.props.loadData(1, filters);
  };

  render() {
    const { addMessage } = this.props;

    return (
      <Grid key="toolbar-avvisi">
        <Grid.Column width={4}>
          <b style={{ display: 'block', marginBottom: '5px' }}>Messaggio</b>
          <Input
            className="editoravvisi-search"
            placeholder="Messaggio"
            fluid
            onChange={(_event, { value }) => this.setState({ message: value })}
            onKeyDown={this.handleSearchEnter}
            value={this.state.message}
          />
        </Grid.Column>
        <Grid.Column width={4}>
          <b style={{ display: 'block', marginBottom: '5px' }}>Gravità</b>
          <Select
            value={this.state.gravita}
            options={[
              { key: 'empty', value: '--', text: '--' },
              { key: 'error', value: 'error', text: 'Error' },
              { key: 'warning', value: 'warning', text: 'Warning' },
              { key: 'info', value: 'info', text: 'Info' },
            ]}
            onChange={(_event, { value }) => this.setState({ gravita: value })}
            placeholder="Gravità"
          />
        </Grid.Column>
        <Grid.Column width={4} textAlign="right" floated="right" verticalAlign="bottom">
          <Button
            icon="search"
            labelPosition="left"
            content="Cerca"
            positive
            onClick={this.applyFilters}
            style={{ marginRight: 15 }}
          />
          <Button icon="plus" labelPosition="left" primary content="Aggiungi" onClick={addMessage} />
        </Grid.Column>
      </Grid>
    );
  }
}

FilterBar.propTypes = {
  loadData: PropTypes.func.isRequired,
  addMessage: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/components/EditorAvvisi/FilterBar/index.js